import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { ScreenSizeService } from '../../../core/services/screen-size.service';

@Component({
  selector: 'app-newsletter-footer',
  imports: [TranslatePipe],
  templateUrl: './newsletter-footer.component.html',
  styleUrl: './newsletter-footer.component.scss',
  host: { '[class.mobile]': 'isPhoneOrTablet()' },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NewsletterFooterComponent {
  private screenSizeService = inject(ScreenSizeService);
  protected isPhoneOrTablet = this.screenSizeService.isPhoneOrPortraitTablet;
}
